import get from 'lodash/get';

import { optimizePath } from '../../helpers/optimize-path';

export const ChannelProvider = {
  get name() {
    return 'CHANNEL_PROVIDER';
  },

  isRotationEnabled(config, { account }) {
    return this.creatives(config, account).length > 1;
  },

  rotationInterval(config) {
    return config.plusRotationInterval;
  },

  test(config, { account }) {
    return this.creatives(config, account).length > 0;
  },

  creatives(config, account) {
    // Show channel wallpapers first. This allows to see other users wallpapers
    // even if you are logged in into your account.
    return config.channelWallpapers.length > 0
      ? config.channelWallpapers
      : account.wallpapers;
  },

  nextCreative(config, { account, wallpaper }) {
    const creatives = this.creatives(config, account);

    // This is a way to rotate through the elements of an array, because the
    // modulo operator will always return an index inside the array length range
    const nextPosition = wallpaper.position % creatives.length;
    const nextCreative = creatives[nextPosition];

    return this.processCreative(nextCreative);
  },

  processCreative(creative) {
    return {
      format: creative.wallpaperType || 'image',
      src: optimizePath(creative),
      meta: {
        href: creative.href,
        title: get(creative, 'title', ''),
      },
    };
  },
};
